export const FETCH_INSURANCES_REQUEST = "FETCH_INSURANCES_REQUEST";
export const UPDATE_INSURANCE_REQUEST = "UPDATE_INSURANCE_REQUEST";
export const CHANGE_INSURANCE_STATUS_REQUEST = "CHANGE_INSURANCE_STATUS_REQUEST";
export const CHANGE_INSURANCE_WEIGHT_REQUEST = "CHANGE_INSURANCE_WEIGHT_REQUEST";
export const CREATE_INSURANCE_REQUEST = "CREATE_INSURANCE_REQUEST";
